import { Step as StepComponent, StepLabel, Stepper } from "@mui/material";
import { StepIconProps } from "@mui/material/StepIcon";
import { Step, SubStep } from "layout/models/step.model";
import React from "react";
import { useLocation } from "react-router-dom";
import { BftStepperConnector, BftStepperStepIconRoot } from "./components";

interface Props {
	type: "step" | "substep";
	steps: Step[] | SubStep[] | undefined;
	activeStep: Step | SubStep | undefined;
	activeStepIndex: number | undefined;
	orientation: "horizontal" | "vertical";
}

const BftStepper: React.FC<Props> = (props) => {
	const { type, activeStepIndex, activeStep, steps, orientation } = props;

	const location = useLocation();

	type ConditionalType<T extends string> = T extends "step" ? Step : SubStep;

	var _steps: ConditionalType<typeof type>[] = [];

	if (steps) _steps = steps;

	const checkCompleted = (step: Step | SubStep) => {
		if (!activeStep?.id || !activeStepIndex) return false;

		let stepIndex = steps?.map((s) => s.id)?.indexOf(step?.id);

		return stepIndex != undefined ? stepIndex < activeStepIndex : false;
	};

	const BftStepperStepIcon = (props: StepIconProps) => {
		const { active, completed, className } = props;

		return (
			<BftStepperStepIconRoot ownerState={{ active }} className={className}>
				{completed ? (
					<div className="BftStepperStepIcon-completedIcon" />
				) : active ? (
					<div className="BftStepperStepIcon-activeIcon" />
				) : (
					<div className="BftStepperStepIcon-todoIcon" />
				)}
			</BftStepperStepIconRoot>
		);
	};

	return (
		<div
			className={`${
				orientation === "vertical" ? "vertical-stepper-container" : "horizontal-stepper-container"
			}`}
		>
			<Stepper
				activeStep={activeStepIndex}
				orientation={orientation}
				connector={<BftStepperConnector orientation={orientation} />}
			>
				{_steps
					?.filter((s) => !s.hideOnMenu)
					?.map((step, index) => {
						const { title } = step;

						return (
							<StepComponent
								key={`step_${step.id}_${index}`}
								active={location.pathname == step?.route}
								completed={checkCompleted(step)}
							>
								<StepLabel className="p-0" StepIconComponent={BftStepperStepIcon}>
									{orientation === "vertical" && title}
								</StepLabel>
							</StepComponent>
						);
					})}
			</Stepper>
		</div>
	);
};

export default BftStepper;
